import _ from "lodash";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../../store/rootReducer";
import { useSelector } from "react-redux";
import SelectCampus from "../../../SelectCampus";
import { DatePicker, Select, Table, TableColumnsType } from "antd";
import { getReverseYears } from "../../../../lib/util";
import { useEffect, useRef, useState } from "react";
import Button from "../../../Button";
import moment from "moment";
import Split from "react-split";
import { IClosingSettleAccount, IClosingInEx, IClosingSettle, IDateClosing, IExpenseListParams, IGetClosingInEx, IGetClosingSettle, IGetDateClosing, IIncomeListParams, IClosingSettleParam, IGetClosingSettleAccount } from "../../../../models/financials.model";
import useAxios from "../../../../hooks/useAxios";
import { createClosingSettle, getClosingDates, getClosingExpenses, getClosingIncomes, getClosingSettle, getClosingSettleAccount, updateClosingCancle } from "../../../../api/financials.api";
import { IResponse } from "../../../../models/common.api.model";
import useNotification from "../../../../hooks/useNotification";
import ConfirmModal from "../../../modals/ConfirmModal";
import Loader from "../../../Loader";

const ClosingList = () => {

    const maxPageSize = 9999999;
    const { t, i18n } = useTranslation();
    const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
    const { infoNotification, successNotification } = useNotification();
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // SY0005 = 연도
    const SY0005 = commonCodes.find(item => item.commonCode === 'SY0005')?.detailCode;
    // SY0009 = 월
    const SY0009 = commonCodes.find(item => item.commonCode === 'SY0009')?.detailCode; 

    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [searchMonth, setSearchMonth] = useState('');
    const [inPage, setInPage] = useState(1);
    const [exPage, setExPage] = useState(1);
    const [dateRefineList, setDateRefineList] = useState<IDateClosing[]>([]);
    const [incomeRefineList, setIncomeRefineList] = useState<IClosingInEx[]>([]);
    const [expenseRefineList, setExpenseRefineList] = useState<IClosingInEx[]>([]);
    const [settleRefineData, setSettleRefineData] = useState<IClosingSettle>();
    const [settleAccountRefineList, setSettleAccountRefineList] = useState<IClosingSettleAccount[]>([]);
    const [settleDate, setSettleDate] = useState('');
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [todayIncome, setTodayIncome] = useState(0);          //금일수입
    const [todayExpense, setTodayExpense] = useState(0);        //금일지출
    const [todayKeepAmount, setTodayKeepAmount] = useState(0);  //보관금
    const [isInit, setIsInit] = useState(false);    //최초 입력 여부
    const [initBeforeAmount, setInitBeforeAmount] = useState(0);    //최초 입력 시 전일잔고
    const [calBalance, setCalBalance] = useState(0);    //잔고 합 계산용 필드
    const [confirmCancelVisible, setConfirmCancelVisible] = useState(false);
    const dateArea = useRef<any>();
    
    const {data: incomeList, isLoading: isLoading1, error: error1, execute: executeIncomeList } = useAxios<IGetClosingInEx>();
    const {data: expenseList, isLoading: isLoading2, error: error2, execute: executeExpenseList } = useAxios<IGetClosingInEx>();
    const {data: dateList, isLoading: isLoading3, error: error3, execute: executeDateList } = useAxios<IGetDateClosing>();
    const {data: settleData, isLoading: isLoading4, error: error4, execute: executeSettleData } = useAxios<IGetClosingSettle>();
    const {data: resData, isLoading: isLoading5, error: error5, execute: executeCreateSettle } = useAxios<IResponse<string>>();
    const {data: resData2, isLoading: isLoading7, error: error7, execute: executeClosingCancel } = useAxios<IResponse<string>>();
    const {data: settleAccountList, isLoading: isLoading6, error: error6, execute: executeSettleAccountData } = useAxios<IGetClosingSettleAccount>();

    useEffect(() => {
        const defaultDate = moment(new Date());
        const tYear = moment(defaultDate).format('YYYY');
        const tMonth = moment(defaultDate).format('MM');
        setYear(tYear);
        setMonth(tMonth);
        setSearchMonth(tMonth);
        setSettleDate(moment(defaultDate).format('YYYYMMDD'));

        getDateList(tYear, tMonth);
    },[]);

    useEffect(() => {
        if(dateList) {
            let tempDateList : any[]  = _.cloneDeep(dateList.data);
            setDateRefineList(tempDateList);
        }
    }, [dateList]);

    useEffect(() => {
        if(incomeList) {
            let tempIncomeList : any[]  = _.cloneDeep(incomeList.data);
            let tempTotalOnline: number = 0;
            let tempTotalCash: number = 0;
            let tempTotalCard: number = 0;

            if (tempIncomeList.length > 0) {
                tempIncomeList.forEach((item: any) => {
                    //total
                    tempTotalOnline += item.onAmount;
                    tempTotalCash += item.csAmount;
                    tempTotalCard += item.cdAmount;
                });

                setTodayIncome(tempTotalOnline + tempTotalCash + tempTotalCard);    //입출금현황 금일 수입
                tempIncomeList.push({secondName:t('cbt.test.column22'), onAmount:tempTotalOnline, csAmount:tempTotalCash, cdAmount:tempTotalCard});
            } else {
                setTodayIncome(0);
            }
            setIncomeRefineList(tempIncomeList);
        }
    }, [incomeList]);

    useEffect(() => {
        if(expenseList) {
            let tempExpenseList : any[]  = _.cloneDeep(expenseList.data);
            let tempTotalOnline: number = 0;
            let tempTotalCash: number = 0;
            let tempTotalCard: number = 0;

            if (tempExpenseList.length > 0) {
                tempExpenseList.forEach((item: any) => {
                    //total
                    tempTotalOnline += item.onAmount;
                    tempTotalCash += item.csAmount;
                    tempTotalCard += item.cdAmount;
                });
                setTodayExpense(tempTotalOnline + tempTotalCash + tempTotalCard);    //입출금현황 금일 지출
                tempExpenseList.push({secondName:t('cbt.test.column22'), onAmount:tempTotalOnline, csAmount:tempTotalCash, cdAmount:tempTotalCard});
            } else {
                setTodayExpense(0);
            }
            setExpenseRefineList(tempExpenseList);
        }
    }, [expenseList]);

    useEffect(() => {
        if(settleData) {
            let tempSettleData : IClosingSettle = _.cloneDeep(settleData.data);

            if (tempSettleData) {
                if(tempSettleData.settleDate === settleDate) {
                    setTodayKeepAmount(tempSettleData.keepAmount);  //보관금
                    //금일잔고 = 저일잔고 + 금일 수입 - 금일 지출
                    setSettleRefineData(tempSettleData);

                    //수입, 지출 목록 셋팅
                    getIncomeList();
                    getExpenseList();

                } else {
                    //각종 Data 초기화
                    getInitData();
                }
            } else {
                getInitData();
            }
        }
    }, [settleData]);

    useEffect(() => {
        if(settleAccountList) {
            let tempSettleAccountList : IClosingSettleAccount[] = _.cloneDeep(settleAccountList.data);

            if (tempSettleAccountList) {
                if(tempSettleAccountList.length > 0 && tempSettleAccountList[0].settleDate === settleDate) {
                    let tempTotalBalance = 0;
                    let tempSettleDate = '';
                    let tempCampusCode = '';
                    tempSettleAccountList.forEach((item: IClosingSettleAccount) => {
                        item.isTotal = false;
                        tempSettleDate = item.settleDate;
                        tempCampusCode = item.campusCode;
                        tempTotalBalance += item.amount;
                    });

                    tempSettleAccountList.push({settleDate: tempSettleDate, campusCode:tempCampusCode, accountGbn:t('cbt.test.column22'), accountName:'', accountNo: '', accountSeq: 0
                        ,amount:tempTotalBalance, isTotal:true});

                    setCalBalance(tempTotalBalance);
                    setSettleAccountRefineList(tempSettleAccountList);
                } else {
                    setCalBalance(0);
                    setSettleAccountRefineList([]);
                }
            }
        }
    }, [settleAccountList]);

    useEffect(()=>{
        getDateList(year, month);
        getSettleData(settleDate);
        getInitData();
    },[currentCampus]);

    useEffect(() => {
        if(resData) {
            if(resData.result === "success") {
                successNotification(t('common.message.save1'));

                getInitData();
                getDateList(year, month);
                getSettleData(settleDate);
                setInExInfo();
            }
        }
    }, [resData]);

    useEffect(() => {
        if(resData2) {
            if(resData2.result === "success") {
                successNotification(t('common.message.save1'));

                getInitData();
                getDateList(year, month);
                getSettleData(settleDate);
                setInExInfo();
            }
        }
    }, [resData2])

    //데이터 초기화
    const getInitData = () => {
        setIncomeRefineList([]);
        setExpenseRefineList([]);
        setSettleRefineData(undefined);
        setTodayIncome(0);
        setTodayExpense(0);
        setTodayKeepAmount(0);
        setInitBeforeAmount(0);
        setIsInit(false);
        setSettleAccountRefineList([]);
        setCalBalance(0);
    }

    //좌측 일별 목록 가져오기
    const getDateList = (tYear:string, tMonth:string) => {
        if(tYear && tMonth) {
            executeDateList(getClosingDates(tYear, tMonth, currentCampus));
        }
    }

    //검색버튼 클릭 시 
    const getSearchClosing = () => {
        getDateList(year, month);
        setIncomeRefineList([]);
        setExpenseRefineList([]);
        setSearchMonth(month);
    }

    //입출금, 잔고현황 가져오기
    const getSettleData = (tSettleDate:string) => {
        executeSettleData(getClosingSettle(tSettleDate, currentCampus));
        executeSettleAccountData(getClosingSettleAccount(tSettleDate, currentCampus));
    }

    //수입 지출 내역 적용
    const setInExInfo = () => {
        getIncomeList();
        getExpenseList();

        if(settleData) {
            let tempSettleData : IClosingSettle = _.cloneDeep(settleData.data);
            if (tempSettleData) {
                setSettleRefineData(tempSettleData);

                if(settleAccountList) {
                    let tempSettleAccountList : IClosingSettleAccount[] = _.cloneDeep(settleAccountList.data);
                    if (tempSettleAccountList) {
                        let tempSettleDate = '';
                        let tempCampusCode = '';
                        tempSettleAccountList.forEach((item: IClosingSettleAccount) => {
                            item.isTotal = false;
                            tempSettleDate = item.settleDate;
                            tempCampusCode = item.campusCode;
                        });
    
                        tempSettleAccountList.push({settleDate: tempSettleDate, campusCode:tempCampusCode, accountGbn:t('cbt.test.column22'), accountName:'', accountNo: '', accountSeq: 0
                            ,amount:0, isTotal:true});
                            
                        setSettleAccountRefineList(tempSettleAccountList);
                    }
                }
            } else {
                setIsInit(true);
            }
        }
    }

    //수입 내역
    const getIncomeList = () => {
        const campusCode = currentCampus;
        
        const incomeListParam: IIncomeListParams = {
            campusCodes: [campusCode],
            searchType: 'ID',
            firstIncomeAccCode: '',
            secondIncomeAccCode: '',
            thirdIncomeAccCode: '',
            incomeMtd: '',
            incomeYn: '',
            incomeSrtDate: settleDate,
            incomeEndDate: settleDate,
            treeCommonCode: "FA0002",
            pageNo: inPage,
            perPage: maxPageSize
        }

        executeIncomeList(getClosingIncomes(incomeListParam));
        setInPage(1);
    }

    //지출 내역
    const getExpenseList = () => {
        const campusCode = currentCampus;

        const expenseListParam: IExpenseListParams = {
            campusCodes: [campusCode],
            searchType: 'ED',
            firstExpenseAccCode: '',
            secondExpenseAccCode: '',
            thirdExpenseAccCode: '',
            approvalStatus: 'CO',
            expenseMtd: '',
            expenseYn: '',
            expenseSrtDate: settleDate,
            expenseEndDate: settleDate,
            title: '',
            treeCommonCode: "FA0001",
            commentYn: '',
            pageNo: exPage,
            perPage: maxPageSize
        }

        executeExpenseList(getClosingExpenses(expenseListParam));
        setExPage(1);
    }

    //좌측 일별 목록 클릭
    const closingDateRowClick = (record : any) => {
        setSelectedRow(record);
        let tempSettleDate = moment(record.settleDate).format('YYYYMMDD');
        setSettleDate(tempSettleDate);

        getSettleData(tempSettleDate);
    }

    /* 잔고현황 Data 핸들링 */
    //잔고현황 Data 수정
    const onSetData = (index: number, key: string, value: string) => {
        const _data: any = [...settleAccountRefineList];
        _data[index][key] = value;
        setSettleAccountRefineList(_data);
    };

    //잔고현황 추가
    const onAddRow = () => {
        const _data: IClosingSettleAccount[] = [...settleAccountRefineList];
        _data.splice(_data.length-1, 1);
        
        _data.push({
          settleDate: settleDate,
          campusCode: currentCampus,
          accountSeq: 0,
          accountGbn: '',
          accountName: '',
          accountNo: '',
          amount: 0,
          isTotal: false
        });

        let tempNo = 1;
        let tempTotalBalance = 0;
        let tempSettleDate = '';
        let tempCampusCode = '';
        _data.forEach((item) => {
            item.accountSeq = tempNo;
            item.isTotal = false;
            tempSettleDate = item.settleDate;
            tempCampusCode = item.campusCode;
            tempTotalBalance += item.amount;
            tempNo++;
        });

        _data.push({settleDate: tempSettleDate, campusCode:tempCampusCode, accountGbn:t('cbt.test.column22'), accountName:'', accountNo: '', accountSeq: 0
            ,amount:tempTotalBalance, isTotal:true});

        setCalBalance(tempTotalBalance);
        setSettleAccountRefineList(_data);
    };

    //잔고현황 삭제
    const onDeleteRow = (index: number) => {
        const _data: IClosingSettleAccount[] = [...settleAccountRefineList];
        _data.splice(index, 1);
        _data.splice(_data.length-1, 1);

        let tempNo = 1;
        let tempTotalBalance = 0;
        let tempSettleDate = '';
        let tempCampusCode = '';
        _data.forEach((item) => {
            item.accountSeq = tempNo;
            item.isTotal = false;
            tempSettleDate = item.settleDate;
            tempCampusCode = item.campusCode;
            tempTotalBalance += item.amount;
            tempNo++;
        });

        _data.push({settleDate: tempSettleDate, campusCode:tempCampusCode, accountGbn:t('cbt.test.column22'), accountName:'', accountNo: '', accountSeq: 0
            ,amount:tempTotalBalance, isTotal:true});

        setCalBalance(tempTotalBalance);
        setSettleAccountRefineList(_data);
    }

    //잔고현황 합계
    const onSetTotalBalance = (index: number, key: string, value: string) => {
        const _data: any = [...settleAccountRefineList];
        _data[index][key] = value;
        _data.splice(_data.length-1, 1);

        let tempNo = 1;
        let tempTotalBalance = 0;
        let tempSettleDate = '';
        let tempCampusCode = '';
        _data.forEach((item:any) => {
            item.accountSeq = tempNo;
            item.isTotal = false;
            tempSettleDate = item.settleDate;
            tempCampusCode = item.campusCode;
            tempTotalBalance += Number(item.amount);
            tempNo++;
        });

        _data.push({settleDate: tempSettleDate, campusCode:tempCampusCode, accountGbn:t('cbt.test.column22'), accountName:'', accountNo: '', accountSeq: 0
            ,amount:tempTotalBalance, isTotal:true});

        setCalBalance(tempTotalBalance);
        setSettleAccountRefineList(_data);
    }

    //저장, 마감
    const onSave = (closeYn:string) => {
        //파라미터 셋팅
        let tempBeforeAmount = 0;
        let tempTodayAmount = 0;
        if(settleRefineData) {
            tempBeforeAmount =  settleRefineData.beforeAmount;
            tempTodayAmount = settleRefineData.beforeAmount + todayIncome - todayExpense;
        } else if(isInit) {
            tempBeforeAmount =  initBeforeAmount;
            tempTodayAmount = initBeforeAmount + todayIncome - todayExpense;            
        }

        const _data: IClosingSettleAccount[] = [...settleAccountRefineList];
        _data.splice(_data.length-1, 1);

        const paramData : IClosingSettleParam = {
            settleDate: settleDate,
            campusCode: currentCampus,
            beforeAmount: tempBeforeAmount,
            todayAmount: tempTodayAmount,
            incomeAmount: todayIncome,
            expenseAmount: todayExpense,
            keepAmount: todayKeepAmount,
            closeYn: closeYn,
            accountList: _data
        };

        executeCreateSettle(createClosingSettle(paramData));
    }

    //마감취소
    const onCloseCancel = () => {
        const form = new FormData();

        form.append('campusCode', currentCampus);
        form.append('settleDate', settleDate);

        executeClosingCancel(updateClosingCancle(form));
        setConfirmCancelVisible(false);
    }

    //비고 0 체크
    const checkBalance = () => {
        let tempCheck: boolean = true;
        if(settleRefineData) {
            if((settleRefineData.beforeAmount + todayIncome - todayExpense - calBalance) === 0) {
                tempCheck =  false;
            }
        } else if(isInit) {
            if((initBeforeAmount + todayIncome - todayExpense - calBalance) === 0) {
                tempCheck = false;
            }
        }
        return tempCheck;
    }

    //각 테이블 컬럼
    const closingColumns: TableColumnsType<IDateClosing> = [
        {
            title: t('class.class.column42'),
            dataIndex: 'settleDate',
            key: 'settleDate',
            align: 'center',
        },
        {
            title: t('payment.income.column5'),
            dataIndex: 'closeYn',
            key: 'closeYn',
            align: 'center',
            render: (value) => (value==="Y"?(
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 9.938 9.647 15 16 6" stroke="#5DBECD" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ):"")
        },
        {
            title: t('student.student.47'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
        {
            title: t('payment.closing.column1'),
            dataIndex: 'closeDate',
            key: 'closeDate',
            align: 'center',
            render: (value)=>((value)&&moment(value).format("YYYY-MM-DD"))
        },
        {
            title: t('payment.closing.column2'),
            dataIndex: 'balance',
            key: 'balance',
            align: 'center',
            render: (value)=>((value != null)&&('￦' + value.toLocaleString()))
        },
    ];

    const inExColumns: TableColumnsType<IClosingInEx> = [
        {
            title: t('payment.income.search2') + 1,
            dataIndex: 'firstName',
            key: 'firstName',
            align: 'center',
        },
        {
            title: t('payment.income.search2') + 2,
            dataIndex: 'secondName',
            key: 'secondName',
            align: 'center',
        },
        {
            title: t('payment.income.search2') + 3,
            dataIndex: 'thirdName',
            key: 'thirdName',
            align: 'center',
        },
        {
            title: t('payment.inex.column4'),
            dataIndex: 'csAmount',
            key: 'csAmount',
            align: 'center',
            render: (value)=>((value != null)&&('￦' + value.toLocaleString()))
        },
        {
            title: t('entrance.schedule.option4'),
            dataIndex: 'onAmount',
            key: 'onAmount',
            align: 'center',
            render: (value)=>((value != null)&&('￦' + value.toLocaleString()))
        },
        {
            title: t('student.student.text6'),
            dataIndex: 'cdAmount',
            key: 'cdAmount',
            align: 'center',
            render: (value)=>((value != null)&&('￦' + value.toLocaleString()))
        },
    ];

    const balanceColumns: TableColumnsType<IClosingSettleAccount> = [
        {
            title: '#',
            dataIndex: 'accountSeq',
            key: 'accountSeq',
            align: 'center',
            width: 50,
            render: (value, record) => (
                (!record.isTotal)?(value):('')
            )
        },
        {
            title: t('campus.shuttle.column4'),
            dataIndex: 'accountGbn',
            key: 'accountGbn',
            align: 'center',
            render: (value, record, index) => (
                (!record.isTotal)?(
                <div className="w-100">
                    <input
                    type="text"
                    className="form-control"
                    value={value}
                    onChange={(e) => onSetData(index, 'accountGbn', e.target.value)}
                    />
                </div>)
                :(value)
            )
        },
        {
            title: t('payment.closing.column3'),
            dataIndex: 'accountName',
            key: 'accountName',
            align: 'center',
            render: (value, record, index) => (
                (!record.isTotal)?(
                <div className="w-100">
                    <input
                    type="text"
                    className="form-control"
                    value={value}
                    onChange={(e) => onSetData(index, 'accountName', e.target.value)}
                    />
                </div>
                ):''
            )
        },
        {
            title: t('campus.shuttle.column13'),
            dataIndex: 'accountNo',
            key: 'accountNo',
            align: 'center',
            render: (value, record, index) => (
                (!record.isTotal)?(
                <div className="w-100">
                    <input
                    type="text"
                    className="form-control"
                    value={value}
                    onChange={(e) => onSetData(index, 'accountNo', e.target.value)}
                    />
                </div>
                ):''
            )
        },
        {
            title: t('payment.closing.column4'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'center',
            render: (value, record, index) => (
                (!record.isTotal)?(
                <div className="w-100 flex">
                    <input
                    type="number"
                    className="form-control text-right"
                    value={value}
                    
                    onChange={(e) => {
                        if(!e.target.value) {
                            return false;
                        }
                        if(Number(e.target.value) < 0) {
                            return false;
                        }
                        onSetData(index, 'amount', e.target.value)
                    }}
                    onBlur={(e) => {
                        if(!e.target.value) {
                            return false;
                        }
                        if(Number(e.target.value) < 0) {
                            return false;
                        }
                        onSetTotalBalance(index, 'amount', e.target.value);
                    }}
                    />
                    <div className="v-line pl-1">
                        {t('campus.setting.text2')}
                    </div>
                </div>
                ):(value)&&(value.toLocaleString() + ' ' +t('campus.setting.text2'))
            )
        },
        {
            title: t('campus.shuttle.column20'),
            align: 'center',
            width: 50,
            render: (value, record, index) => (
                (!record.isTotal)?(
                <div>
                     <button type="button" className="btn-delete" onClick={()=>onDeleteRow(index)}></button>
                </div>
                ):''
            )
        },
    ];

    return (
        <>
            {isLoading1 || isLoading2 || isLoading3 || isLoading4 || isLoading5 || isLoading7 ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            <SelectCampus />
                        </li>
                        <li>
                            <label>{t('statistics.refund.placeholder1')}</label> {/* 연도 */}
                            <Select
                                placeholder={t('statistics.refund.placeholder1')}
                                value={year}
                                onChange={value => setYear(value)}
                            >
                            {getReverseYears(SY0005).map(item => (
                                <Select.Option
                                key={item.detailCode}
                                value={item.detailCode}
                                >
                                {item.korName}
                                </Select.Option>
                            ))}
                            </Select>
                        </li>
                        <li>
                            <label>{t('cbt.test.column8')}</label> {/* 월 */}
                            <Select
                                placeholder={t('common.button.select')}
                                value={month}
                                onChange={value => setMonth(value)}
                                >
                                {
                                    SY0009?.map((item: any) => {
                                    return (
                                        <Select.Option
                                        key={item.detailCode}
                                        value={item.detailCode}
                                        >
                                        {i18n.language === 'ko' ? item.korName : item.engName}
                                        </Select.Option>
                                    )})
                                }
                                </Select>            
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getSearchClosing()}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <Split 
                className='splite-divide'
                sizes={[30, 70]}
                minSize={100}
                expandToMin={false}
                gutterSize={10}
                gutterAlign="center"
                snapOffset={30}
                dragInterval={1}
                direction="horizontal"
                cursor="col-resize"
            >
                <div className='col-frame left_panel wrap-financial'>
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{searchMonth + t('cbt.test.column8') + ' ' +t('payment.income.column5')}</h3></div>                
                    </div>
                    <div className="comm-table__area">
                        <Table
                            columns={closingColumns}
                            dataSource={dateRefineList}
                            rowKey={'settleDate'}
                            onRow={(record) => {
                                return {
                                onClick: () => {
                                    closingDateRowClick(record);
                                },
                                };
                            }}
                            rowClassName={(record: any) =>
                                record.settleDate === selectedRow?.settleDate
                                    ? 'chosen'
                                    : 'pointer'
                            }
                            pagination={{
                                current: 1,
                                pageSize: 99,
                            }}
                        />
                        
                    </div>

                </div>
                <div className='finan_right_panel'>
                    <div ref={dateArea} ></div>
                    {/* 마감정보 */}
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{t('payment.closing.label1')}</h3></div>
                    </div>
                    <div className="comm-table__area rowType">
                        <table>
                            <colgroup>
                                <col width="10%" />
                                <col width="30%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="30%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{t('class.class.column42')}</th>
                                    <td>
                                        <div className="comm-btn__area">
                                            <div className="date-picker__area">
                                                <DatePicker
                                                value={settleDate ? moment(settleDate) : undefined}
                                                onChange={e => {
                                                    if (e === null) setSettleDate('');
                                                    else setSettleDate(moment(e).format('YYYYMMDD'))

                                                    getSettleData(moment(e).format('YYYYMMDD'));
                                                }}
                                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                                getPopupContainer={() => {
                                                    return dateArea.current as HTMLElement;
                                                }}
                                                />
                                            </div>
                                            <Button
                                                className="btn-basic mint-line"
                                                onClick={() => setInExInfo()}
                                                text={t('payment.closing.btn1')}
                                                disabled={settleRefineData?.closeYn === 'Y' ? true:false}
                                            />
                                        </div>
                                    </td>
                                    <th>{t('payment.closing.label2')}</th>
                                    <td className="text-center">{settleRefineData?.closeYn === 'Y' ? 'O' : 'X'}</td>
                                    <th>{t('class.class.column93')}</th>
                                    <td>{auth.korName + '(' + auth.engName + ')'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 수입 */}
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{t('payment.income.tab1')}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <Table
                            columns={inExColumns}
                            dataSource={incomeRefineList}
                            rowKey={'paymentTargetCode'}
                            rowClassName={(record: IClosingInEx) => (!record.firstCode) ? 'tfoot' : ''}
                        />
                    </div>
                    {/* 지출 */}
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{t('payment.income.tab2')}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <Table
                            columns={inExColumns}
                            dataSource={expenseRefineList}
                            rowKey={'paymentTargetCode'}
                            rowClassName={(record: IClosingInEx) => (!record.firstCode) ? 'tfoot' : ''}
                        />
                    </div>
                    {/* 입출금 현황 */}
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{t('payment.closing.label3')}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <table>
                            <colgroup>
                                <col width="20%" />
                                <col width="20%" />
                                <col width="20%" />
                                <col width="20%" />
                                <col width="20%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{t('payment.closing.label4')}</th>
                                    <th>{t('payment.closing.label5')}</th>
                                    <th>{t('payment.closing.label6')}</th>
                                    <th>{t('payment.closing.label7')}</th>
                                    <th>{t('program.criteria.column5')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    settleRefineData ? (
                                    <tr>
                                        <td>{'￦' + (settleRefineData.beforeAmount).toLocaleString()}</td>
                                        <td>{'￦' + todayIncome.toLocaleString()}</td>
                                        <td>{'￦' + todayExpense.toLocaleString()}</td>
                                        <td>{'￦' + (settleRefineData.beforeAmount + todayIncome - todayExpense).toLocaleString()}</td>
                                        <td>{'￦' + (settleRefineData.beforeAmount + todayIncome - todayExpense - calBalance).toLocaleString()}</td> {/*비고 = 잔고현황 금일잔고 차액*/}
                                    </tr>
                                    ) : (isInit) && (
                                        <tr>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control input-text text-right"
                                                    value={initBeforeAmount}
                                                    onChange={e => {
                                                        if(!e.target.value) {
                                                            return false;
                                                        }
                                                        setInitBeforeAmount(Number(e.target.value));
                                                    }}
                                                />
                                            </td> {/* input_box */}
                                            <td>{todayIncome}</td>
                                            <td>{todayExpense}</td>
                                            <td>{initBeforeAmount + todayIncome - todayExpense}</td>
                                            <td>{initBeforeAmount + todayIncome - todayExpense - calBalance}</td> {/*비고 = 잔고현황 금일잔고 차액*/}
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    {/* 잔고 현황 */}
                    <div className="w-100 flex">
                        <div style={{width:'80%'}}>
                            <div className="comm-bx__between">
                                <div><h3 className='sub-title'>{t('payment.closing.label8')}</h3></div>
                                <div className="comm-btn__area right">
                                    <Button
                                        className="btn-basic pink-line"
                                        onClick={() => onAddRow()}
                                        text={t('common.button.add')}
                                    />
                                </div>
                            </div>
                            <div className="comm-table__area closing">
                                <Table
                                    columns={balanceColumns}
                                    dataSource={settleAccountRefineList}
                                    rowKey={'paymentTargetCode'}
                                    rowClassName={(record: IClosingSettleAccount) => (record.isTotal) ? 'tfoot' : ''}
                                    pagination={{
                                        current: 1,
                                        pageSize: 999999999,
                                    }}
                                />
                            </div>
                            <div className="comm-bx__between">
                                <div></div>
                                <div className="comm-btn__area right">
                                    <Button
                                        className="btn-basic mint"
                                        onClick={() => onSave('Y')}
                                        disabled={checkBalance() || settleRefineData?.closeYn === 'Y' || isInit}
                                        text={t('payment.income.column5')}
                                    />
                                    {(auth.hqYn === 'Y') &&
                                        <Button
                                            className="btn-basic gray"
                                            onClick={()=>{setConfirmCancelVisible(true)}}
                                            disabled={(!(settleRefineData?.settleDate === settleDate && settleRefineData?.closeYn === 'Y'))}
                                            text={t('payment.closing.btn2')}
                                        />
                                    }
                                    <Button
                                        className="btn-basic pink"
                                        onClick={() => onSave('N')}
                                        disabled={(!isInit) && settleRefineData?.closeYn === 'Y'}
                                        text={t('common.button.save')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{width:'20%'}} className="ml-2">
                            <div className="comm-bx__between">
                            </div>
                            <div className="comm-table__area">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{t('payment.closing.label9')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="flex">
                                                    <input
                                                        type="number"
                                                        className="form-control input-text text-right"
                                                        value={todayKeepAmount}
                                                        onChange={e => {
                                                            if(!e.target.value) {
                                                                return false;
                                                            }
                                                            if(Number(e.target.value) < 0) {
                                                                return false;
                                                            }
                                                            setTodayKeepAmount(Number(e.target.value));
                                                        }}
                                                    /> 
                                                    <div className="v-line pl-1">
                                                        {t('campus.setting.text2')}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {confirmCancelVisible && (
                    <ConfirmModal
                    visible={confirmCancelVisible}
                    setVisible={setConfirmCancelVisible}
                    onConfirm={onCloseCancel}
                    titleText={t('payment.closing.btn2')}
                    messageText={t('payment.closing.msg1')}
                    confirmText={t('payment.closing.btn2')}
                    cancelText={t('common.button.close')}
                    />
                )}
            </Split>
        </>
    )
}

export default ClosingList;